import { render, staticRenderFns } from "./table.vue?vue&type=template&id=19a13f34"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a13f34')) {
      api.createRecord('19a13f34', component.options)
    } else {
      api.reload('19a13f34', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=19a13f34", function () {
      api.rerender('19a13f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign/table.vue"
export default component.exports